<script lang="ts">
	import Switch from '$lib/components/atoms/switch/Switch.svelte';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import * as m from '$paraglide/messages';

	const { isTrafficInfoPageSwitchOn, trafficEventSummary } = getMapLayoutContext();

	function updateSwitchState() {
		$isTrafficInfoPageSwitchOn = !$isTrafficInfoPageSwitchOn;

		if (!$isTrafficInfoPageSwitchOn && $trafficEventSummary) {
			$trafficEventSummary = null;
		}

		track({
			action: 'traffic_info_page',
			payload: {
				action: $isTrafficInfoPageSwitchOn ? 'on' : 'off',
				context: 'modal',
			},
		});
	}
</script>

<Switch
	id="traffic-info-page-switch"
	checked={$isTrafficInfoPageSwitchOn}
	onchange={updateSwitchState}
>
	<div class="text-md">{m.map_tools__go_to_traffic_info_page__label()}</div>
</Switch>
